import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import QueueDefaultWidget from "@/components/dynamic/QueueDefaultWidget.vue";
import QueueLeafWidget from "@/components/dynamic/QueueLeafWidget.vue";
import QueueBlocksWidget from "@/components/dynamic/QueueBlocksWidget.vue";
import { ref, computed, onMounted, nextTick } from "vue";

const __default__ = {
  name: "QueueDefaultWidget",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    queueData: {},
    queueConfig: {},
    borderRadius: {},
    config: {}
  },
  setup(__props: any) {

const props = __props;

const template = computed(() => {
  if (!props.config.queueConfig.template) {
    return "boxes";
  }
  return props.config.queueConfig.template;
});

// queueConfig.queues or queueId, only tickets for those queue lines are shown
function getScopedQueueIds(queueConfig: any): number[] | null {
  const queues = queueConfig?.queues;
  if (Array.isArray(queues) && queues.length > 0) {
    return queues.map((id: any) => Number(id)).filter((id) => !Number.isNaN(id));
  }
  const queueId = queueConfig?.queueId;
  if (queueId !== undefined && queueId !== null && queueId !== "") {
    const id = Number(queueId);
    return Number.isNaN(id) ? null : [id];
  }
  return null;
}

function filterTicketsByQueueScope(data: any[], queueConfig: any): any[] {
  const scopeIds = getScopedQueueIds(queueConfig);
  if (!scopeIds || scopeIds.length === 0) {
    return data;
  }
  return data.filter((ticket) => {
    const lineId = Number(ticket.queue_line_id);
    return !Number.isNaN(lineId) && scopeIds.includes(lineId);
  });
}

// queue data scoped by queues, then maxRows ordered by statusUpdateTimestamp
const displayQueueData = computed(() => {
  let data = filterTicketsByQueueScope(props.queueData ?? [], props.config?.queueConfig);
  const raw = props.config?.queueConfig?.maxRows;
  const maxRows = typeof raw === "number" ? raw : Number(raw);
  if (raw == null || raw === undefined || Number.isNaN(maxRows) || maxRows === 0 || maxRows <= 0) {
    return data;
  }
  const byTimestamp = [...data].sort((a, b) => {
    const ta = a?.statusUpdateTimestamp ?? a?.date ?? 0;
    const tb = b?.statusUpdateTimestamp ?? b?.date ?? 0;
    return tb - ta; // descending: most recent first
  });
  return byTimestamp.slice(0, maxRows);
});

//set counter and number text
const numberTxt = ref("");
const counterTxt = ref("");
const setHeaderText = () => {
  const displayData = JSON.parse(localStorage.getItem("display") || "{}");
  const displayConfig = JSON.parse(displayData.config || "{}");
  const qc = props.config?.queueConfig || {};
  const voiceCall = qc.voice_call ?? props.config?.voice_call ?? displayConfig.voice_call;

  if (voiceCall == 1) {
    counterTxt.value =
      qc.textCounter ??
      props.config?.textCounter ??
      displayConfig.textCounter ??
      "";
    numberTxt.value =
      qc.textNumber ??
      props.config?.textNumber ??
      displayConfig.textNumber ??
      "";
  } else {
    const lang = localStorage.getItem("Language");
    if (lang == "fr") {
      counterTxt.value = "Guichet";
      numberTxt.value = "Numéro";
    } else if (lang == "en") {
      counterTxt.value = "Counter";
      numberTxt.value = "Number";
    } else {
      counterTxt.value = "شباك";
      numberTxt.value = "رقم";
    }
  }
};

onMounted(() => {
  setHeaderText();
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (template.value === 'boxes')
      ? (_openBlock(), _createBlock(QueueDefaultWidget, {
          key: 0,
          queueData: displayQueueData.value,
          queueConfig: _ctx.queueConfig,
          "border-radius": _ctx.borderRadius,
          numberTxt: numberTxt.value,
          counterTxt: counterTxt.value,
          config: _ctx.config
        }, null, 8, ["queueData", "queueConfig", "border-radius", "numberTxt", "counterTxt", "config"]))
      : _createCommentVNode("", true),
    (template.value === 'leaf')
      ? (_openBlock(), _createBlock(QueueLeafWidget, {
          key: 1,
          queueData: displayQueueData.value,
          queueConfig: _ctx.queueConfig,
          "border-radius": _ctx.borderRadius,
          numberTxt: numberTxt.value,
          counterTxt: counterTxt.value,
          config: _ctx.config
        }, null, 8, ["queueData", "queueConfig", "border-radius", "numberTxt", "counterTxt", "config"]))
      : _createCommentVNode("", true),
    (template.value === 'blocks')
      ? (_openBlock(), _createBlock(QueueBlocksWidget, {
          key: 2,
          queueData: displayQueueData.value,
          queueConfig: _ctx.queueConfig,
          "border-radius": _ctx.borderRadius,
          numberTxt: numberTxt.value,
          counterTxt: counterTxt.value,
          config: _ctx.config
        }, null, 8, ["queueData", "queueConfig", "border-radius", "numberTxt", "counterTxt", "config"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})